import TileTitle from "./TileTitle.vue";
import { pluginify } from "./../../util";
export default pluginify(TileTitle);
export { TileTitle };
